import * as actionTypes from 'modules/selfServices/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} IsLoadingState */

/** @type {IsLoadingState} */
const initialState = false;

/**
 * @returns {IsLoadingState}
 */
const set = () => true;

/**
 * @returns {IsLoadingState}
 */
const reset = () => initialState;

export default createReducer(initialState, {
  [actionTypes.FETCH_MODEL]: set,
  [actionTypes.FETCH_MODEL_SUCCESS]: reset,
  [actionTypes.FETCH_MODEL_FAILURE]: reset,
});
